export const KEY_CODES = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ENTER: 'Enter',
  NUMPAD_ENTER: 'NumpadEnter',
  NUMPAD1: 'Numpad1',
  NUMPAD3: 'Numpad3',
  NUMPAD7: 'Numpad7',
  SHIFT_LEFT: 'ShiftLeft',
  SHIFT_RIGHT: 'ShiftRight',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
} as const;
